import styled from "@emotion/styled";
import { IconV2, ThemeProps } from "@deliverr/ui";

// This is an IconV2 component with a right margin
export const SpacedIcon = styled(IconV2)<ThemeProps>`
  margin-right: ${({ theme }) => theme.spacing.S2};
`;
